import { IMessageType } from '@/services/signalr/types';
import { IStatusMsg } from '~/api/messages/IStatusMsg';
import { ITripCopyReq } from '~/api/messages/ITripCopyReq';

export const TripCopyReqMsg: IMessageType<ITripCopyReq, IStatusMsg> = {
  requestName: 'TripCopyReq',
  responseName: 'StatusMsg',
};
